import { styled } from '@/styled-system/jsx';

import ConnectedModuleCard from '../ConnectedModuleCard';

export const StyledConnectedModuleCard = styled(ConnectedModuleCard, {
  base: {
    lg: { minHeight: '510px' },
  },
});
